/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';

import { UpgradeNudgeLayout } from '@zapier/upsells/src/components/UpgradeNudgeLayout';
import { upgradeReasons } from '@zapier/upsells/src/types';

import { CancelButton } from '../CancelButton';
import { ExtendTrialButton } from '../ExtendTrialButton';
import { NudgeImage } from '../NudgeImage';
import { UpgradeButton } from '../UpgradeButton';

import { getActiveView } from './getActiveView';

export type Props = {
  canExtendTrial: boolean;
  onClose: () => void;
  onExtendTrialClick: () => void;
  onUpgradeClick: () => void;
  wasTriggeredByZapToggle: boolean;
};

export const PathsUpgradeNudge = ({
  canExtendTrial,
  onClose,
  onExtendTrialClick,
  onUpgradeClick,
  wasTriggeredByZapToggle,
}: Props) => {
  const activeView = getActiveView({
    canExtendTrial,
    wasTriggeredByZapToggle,
  });

  const secondaryButton = canExtendTrial ? (
    <ExtendTrialButton key="extend-trial" onClick={onExtendTrialClick} />
  ) : (
    <CancelButton key="cancel" onClick={onClose} />
  );

  return (
    <UpgradeNudgeLayout
      bodyText={activeView.bodyText}
      buttons={[
        <UpgradeButton key="upgrade" onClick={onUpgradeClick} />,
        secondaryButton,
      ]}
      headingText="Paths"
      id="paths"
      image={<NudgeImage type={upgradeReasons.paths} />}
      subtitleText="Paid Feature"
    />
  );
};
